export default "__VITE_ASSET__B$H_Waw7__"